import { IconType } from "react-icons/lib";
import {
  PiBuildingApartmentDuotone,
  PiUsersDuotone,
  PiUserGearFill,
  PiGoogleLogoBold,
  PiWhatsappLogo,
  PiBrowserDuotone,
  PiSignIn,
  PiNotification,
  PiWebhooksLogo,
  PiCardsThree,
  PiUsersThreeDuotone,
  PiPackageDuotone,
  PiCurrencyCircleDollarLight,
  PiMegaphoneBold,
  PiGift,
} from "react-icons/pi";
import { HiDocumentText } from "react-icons/hi";
import { atom } from "jotai";
import { routes } from "@/config/routes.ts";
import {
  MdDiscount,
  MdOutlineContactPhone,
  MdOutlineEmail,
  MdOutlinePrivacyTip,
  MdReport,
  MdSell,
} from "react-icons/md";
import { TbFileInvoice } from "react-icons/tb";
import { Roles } from "@/utilities/types/Users";
import { BsActivity, BsBank } from "react-icons/bs";
import { EFeatureType } from "@/utilities/types/AdvanceFeature";
import { IoAnalytics } from "react-icons/io5";
import { CiMoneyCheck1 } from "react-icons/ci";
import { RiAdvertisementFill } from "react-icons/ri";
import { FaCalculator } from "react-icons/fa";

export interface MenuItemsType {
  id: string;
  name: string;
  title: string;
  icon: IconType;
  badge?: string;
  subMenuItems?: MenuItemsType[];
  href?: string;
  permissions?: Roles[];
  advanceFeatureType?: EFeatureType;
}

export const carbonMenuItems: MenuItemsType[] = [
  {
    id: "dashboard",
    name: "Dashboard",
    title: "Overview",
    icon: PiBrowserDuotone,
    href: routes.dashboard,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },
  {
    id: "users",
    name: "Users",
    title: "Users Management",
    icon: PiUsersDuotone,
    href: routes.user.listing,
    permissions: [Roles.ADMIN],
  },
  {
    id: "project-listing",
    name: "Project Listing",
    title: "Overview",
    icon: PiBuildingApartmentDuotone,
    href: routes.projectListing,
    permissions: [Roles.ADMIN],
    // subMenuItems: [
    //   {
    //     id: "allProjects",
    //     name: "All Projects",
    //     title: "Projects Management",
    //     icon: PiBuildingApartmentDuotone,
    //     href: routes.project.listing,
    //     permissions: [Roles.ADMIN],
    //   },
    //   {
    //     id: "unitTypes",
    //     name: "Unit Types",
    //     title: "Unit Types",
    //     icon: HiOutlineDatabase,
    //     href: routes.unitType.listing,
    //     permissions: [Roles.ADMIN],
    //   },
    //   {
    //     id: "projectCategory",
    //     name: "Project Category",
    //     title: "Project Category",
    //     icon: HiOutlineServer,
    //     href: routes.projectCategory.listing,
    //     permissions: [Roles.ADMIN],
    //   },
    //   {
    //     id: "developer",
    //     name: "Developer",
    //     title: "Developer",
    //     icon: HiOutlinePuzzle,
    //     href: routes.developer.listing,
    //     permissions: [Roles.ADMIN],
    //   },
    // ],
  },
  {
    id: "project-landing-page",
    name: "Landing Pages",
    advanceFeatureType: EFeatureType.LandingPage,
    title: "Landing Pages",
    icon: PiCardsThree,
    href: routes.landingPages.listing,
    permissions: [Roles.ADMIN],
  },
  {
    id: "allLeads",
    name: "All Leads",
    title: "All Leads",
    icon: MdOutlineContactPhone,
    href: routes.contacts.listing,
    permissions: [Roles.ADMIN],
  },
  {
    id: "reports",
    name: "Reports",
    title: "Reports",
    icon: MdReport,
    href: routes.report.listing,
    permissions: [Roles.ADMIN],
  },
  {
    id: "import-data",
    name: "Import Data",
    title: "Import Data",
    icon: PiSignIn,
    href: routes.importData.listing,
    permissions: [Roles.ADMIN],
  },
  {
    id: "mortgage",
    name: "Mortgage",
    title: "Mortgage",
    icon: BsBank,
    href: routes.mortgage.listing,
    permissions: [Roles.ADMIN],
  },
  {
    id: "LDP-packages",
    name: "Landing Page Packages",
    title: "Landing Page Packages",
    icon: PiPackageDuotone,
    subMenuItems: [
      {
        id: "package-listing",
        name: "Package Listing",
        title: "Package Listing",
        icon: PiPackageDuotone,
        href: routes.package.listing,
        permissions: [Roles.ADMIN],
      },
      {
        id: "promotion-listing",
        name: "Promotion Listing",
        title: "Promotion Listing",
        icon: MdDiscount,
        href: routes.promotion.listing,
        permissions: [Roles.ADMIN],
      },
    ],
  },
  {
    id: "payment",
    name: "Payment",
    title: "Payment",
    icon: CiMoneyCheck1,
    subMenuItems: [
      {
        id: "payment-history",
        name: "Payment History",
        title: "Payment History",
        icon: PiCurrencyCircleDollarLight,
        href: routes.package.payment,
        permissions: [Roles.ADMIN],
      },
      {
        id: "invoice-history",
        name: "Invoice History",
        title: "Invoice History",
        icon: TbFileInvoice,
        href: routes.invoice.listing,
        permissions: [Roles.ADMIN],
      },
    ],
  },
  {
    id: "templates",
    name: "Templates",
    title: "Templates",
    icon: HiDocumentText,
    permissions: [Roles.ADMIN],
    subMenuItems: [
      {
        id: "whatsapp",
        name: "WhatsApp",
        title: "WhatsApp",
        icon: PiWhatsappLogo,
        href: routes.whatsapp.listing,
        permissions: [Roles.ADMIN],
      },
      {
        id: "emailTemplate",
        name: "Email",
        title: "Email",
        icon: MdOutlineEmail,
        href: routes.emailTemplate,
        permissions: [Roles.ADMIN],
      },
      {
        id: "privacy-policy",
        name: "Privacy Policy",
        title: "Privacy Policy",
        icon: MdOutlinePrivacyTip,
        href: routes.privacyPolicy,
        permissions: [Roles.ADMIN],
      },
      {
        id: "disclaimer",
        name: "Disclaimer",
        title: "Disclaimer",
        icon: PiNotification,
        href: routes.disclaimer.listing,
        permissions: [Roles.ADMIN],
      },
    ],
  },
  {
    id: "integrations",
    name: "Integrations",
    title: "Integrations",
    icon: PiWebhooksLogo,
    href: routes.integrations,
    permissions: [Roles.ADMIN],
  },
  {
    id: "loginActivity",
    name: "Login Activity",
    title: "Login Activity",
    icon: BsActivity,
    href: routes.loginActivity,
    permissions: [Roles.ADMIN],
  },

  {
    id: "benefits",
    name: "Benefits",
    title: "Benefits",
    icon: PiGift,
    badge: "NEW",
    href: routes.benefits,
    permissions: [Roles.AGENCY],
  },
  {
    id: "advertising",
    name: "Advertising",
    title: "Advertising",
    icon: RiAdvertisementFill,
    href: routes.adReport,
    permissions: [Roles.AGENCY],
    subMenuItems: [
      {
        id: "ad-report",
        name: "Ad Report",
        title: "Ad Report",
        icon: IoAnalytics,
        href: routes.adReport,
        permissions: [Roles.AGENCY],
      },
      {
        id: "ad-credits",
        name: "Ad Credits",
        title: "Ad Credits",
        icon: PiCurrencyCircleDollarLight,
        href: routes.adCredit.dashboard,
        permissions: [Roles.AGENCY],
      },
      {
        id: "cpc-insights",
        name: "CPC Intelligence Suite",
        title: "CPC Intelligence Suite",
        icon: PiCurrencyCircleDollarLight,
        href: routes.CPCInsights,
        permissions: [Roles.AGENCY],
      },
      {
        id: "schedule-campaign-review",
        name: "Schedule Campaign Review",
        title: "Schedule Campaign Review",
        icon: PiCalendarDots,
        href: routes.scheduleCampaignReview,
        permissions: [Roles.AGENCY],
      },
    ],
  },
  // {
  //   id: "projectsInventory",
  //   name: "Projects Inventory",
  //   title: "Projects Management",
  //   advanceFeatureType: EFeatureType.Directory,
  //   icon: PiBuildingApartmentDuotone,
  //   href: routes.project.listing,
  //   permissions: [Roles.AGENCY],
  // },
  {
    id: "myProjects",
    name: "My Projects",
    title: "My Projects",
    advanceFeatureType: EFeatureType.Directory,
    icon: PiBuildingApartmentDuotone,
    href: routes.myProjects,
    permissions: [Roles.AGENCY],
  },
  // {
  //   id: "locations",
  //   name: "All Districts",
  //   title: "All Districts",
  //   icon: HiOutlineLocationMarker,
  //   href: routes.location.listing,
  //   permissions: [Roles.ADMIN],
  // },
  // {
  //   id: "agent-project",
  //   name: "My Website's Projects",
  //   title: "My Website's Projects",
  //   advanceFeatureType: EFeatureType.Directory,
  //   icon: BiBuilding,
  //   href: routes.project.agentListing,
  //   permissions: [Roles.AGENCY],
  // },
  {
    id: "project-landing-page",
    name: "Landing Pages",
    advanceFeatureType: EFeatureType.LandingPage,
    title: "Landing Pages",
    icon: PiCardsThree,
    href: routes.landingPages.listing,
    permissions: [Roles.AGENCY],
  },
  // {
  //   id: "agentLocation",
  //   name: "All Districts",
  //   title: "All Districts",
  //   icon: HiOutlineLocationMarker,
  //   advanceFeatureType: EFeatureType.Directory,
  //   href: routes.agentLocation.listing,
  //   permissions: [Roles.AGENCY],
  // },

  {
    id: "allLeads",
    name: "All Leads",
    title: "All Leads",
    icon: MdOutlineContactPhone,
    href: routes.contacts.listing,
    permissions: [Roles.AGENCY, Roles.USER],
  },
  {
    id: "team-account",
    name: "My Team",
    advanceFeatureType: EFeatureType.TeamAccount,
    title: "My Team",
    icon: PiUsersThreeDuotone,
    href: routes.team.listing,
    permissions: [Roles.AGENCY],
  },
  {
    id: "round-robin",
    advanceFeatureType: EFeatureType.TeamAccount,
    name: "Round Robin Setting",
    title: "Round Robin Setting",
    icon: MdOutlineContactPhone,
    href: routes.robin.listing,
    permissions: [Roles.AGENCY],
  },
  {
    id: "agency-integrations",
    name: "Integrations",
    title: "Integrations",
    icon: PiUserGearFill,
    href: routes.agency.integrations,
    permissions: [Roles.AGENCY],
  },
  {
    id: "websiteSetting",
    name: "Website Setting",
    title: "Website Setting",
    icon: PiUserGearFill,
    href: routes.setting.agency,
    permissions: [Roles.AGENCY],
  },
  {
    id: "google-ads-accounts",
    name: "Google Ads Accounts",
    title: "Google Ads Accounts",
    icon: PiGoogleLogoBold,
    href: routes.setting.googleAdsAccounts,
    permissions: [Roles.ADMIN],
  },
  // {
  //   id: "promotionBanner",
  //   name: "Promotion Banner",
  //   title: "Promotion Banner",
  //   icon: HiOutlineTicket,
  //   href: routes.promotionBanner.listing,
  //   permissions: [Roles.ADMIN, Roles.AGENCY],
  // },
  // {
  //   id: "userPreference",
  //   name: "User Preference Enquiries",
  //   title: "User Preference Enquiries",
  //   icon: HiOutlineDocumentReport,
  //   href: routes.userPreference.listing,
  //   permissions: [Roles.AGENCY],
  // },

  // {
  //   id: "layout",
  //   name: "Layout",
  //   title: "Layout",
  //   icon: HiOutlineDeviceTablet,
  //   href: routes.layout.listing,
  //   permissions: [Roles.AGENCY],
  // },
  {
    id: "follow-up",
    name: "WhatsApp Templates",
    title: "WhatsApp Templates",
    icon: PiWhatsappLogo,
    href: routes.followUp.listing,
    permissions: [Roles.AGENCY, Roles.USER],
  },

  // {
  //   id: "advanced-features",
  //   advanceFeatureType: EFeatureType.IpAccessTrackerTelegram,
  //   name: "Telegram Setting",
  //   title: "Telegram Setting",
  //   icon: PiTelegramLogoDuotone,
  //   href: routes.advanceFeatures,
  //   permissions: [Roles.AGENCY],
  // },

  {
    id: "buy-domain",
    name: "Buy Domain",
    title: "Buy Domain",
    icon: MdSell,
    href: "https://websuite.project.sg/",
    permissions: [Roles.AGENCY],
  },
  {
    id: "calculator-formulas",
    name: "Calculator Formulas",
    title: "Calculator Formulas Configuration",
    icon: FaCalculator,
    permissions: [Roles.ADMIN],
    href: routes.calculatorFormula,
  },

  //sub-user/user role
  {
    id: "websiteSetting",
    name: "Website Setting",
    title: "Website Setting",
    icon: PiUserGearFill,
    href: routes.setting.subUser,
    permissions: [Roles.USER],
  },

  {
    id: "PushNotifications",
    title: "Push Notifications",
    name: "Push Notifications",
    href: routes.pushNotification.listing,
    icon: PiMegaphoneBold,
    permissions: [Roles.ADMIN],
  },
  {
    id: "siteContent",
    name: "Pages",
    title: "Pages",
    icon: HiDocumentText,
    href: routes.siteContent.listing,
    advanceFeatureType: EFeatureType.Directory,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },
];

export const carbonMenuItemAtom = atom(carbonMenuItems[0]);
import { PiCalendarDots } from "react-icons/pi";
